export enum MealType {
  Unknown = 0,
  Appetizers = 1,
  MainCourses = 2,
  Desserts = 3,
  Drinks = 4,
  SideCourses = 5,
  MenuOfTheDay = 6,
  Other = 7
}
